import React from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";

export const Sponsors = (props) => {


    const links=[
        'http://cluj.toyota.ro/',
        'https://www.noah-watch.com/',
        'http://www.gustaenergia.ro/',
        'https://www.neusoft.com/',
        'http://www.publica.ro/',
    ]

    const drawSponsors = () => {
        const iterate = Array.from(Array(links.length).keys())
        return iterate.map((no,index)=>{
            return(
                <Grid key={no} item>
                    <Card style={{maxWidth:props.size}}>
                        <a href={links[index]}><img alt={"sponsor"} style={{width:'100%'}} src={require(`../assets/${no+1}.png`)}/></a>
                    </Card>
                </Grid>
            )
        })
    }

    return(
            <Grid justify={"center"} container spacing={2}>
                {drawSponsors()}
            </Grid>
    )
}
